// extracted by mini-css-extract-plugin
export default {"wrapper":"TodosCatalog_wrapper__RMUNd"};